import { useEffect } from "react";
import { HashRouter, Routes, Route, useNavigate } from "react-router-dom";
import { decodeDeepLink } from "@karat/shared";
import { BottomNav } from "./components/BottomNav";
import { Home } from "./screens/Home";
import { CarsHub } from "./screens/CarsHub";
import { NewToyotaList } from "./screens/NewToyotaList";
import { CarDetail } from "./screens/CarDetail";
import { Inventory } from "./screens/Inventory";
import { UsedCars } from "./screens/UsedCars";
import { Credit } from "./screens/Credit";
import { TradeIn } from "./screens/TradeIn";
import { Consultants } from "./screens/Consultants";
import { Favorites } from "./screens/Favorites";
import { ProposalView } from "./screens/ProposalView";
import { useAppStore } from "./state/store";
import { getDeepLinkPayload, getInitialScreen } from "./telegram";
import { track } from "./analytics/track";

const SCREEN_PARAM_ROUTES: Record<string, string> = {
  "new-toyota": "/cars/new",
  inventory: "/cars/inventory",
  "used-cars": "/cars/used",
  credit: "/credit",
  "trade-in": "/trade-in",
  consultants: "/consultants",
};

/**
 * п.23-24 ТЗ: клієнт після відкриття посилання не повинен починати шлях із головного меню.
 * Обробляє і "screen" (кнопки головного меню бота), і "start" (справжні deep links —
 * конкретний автомобіль/пропозиція, див. packages/shared/deepLinks.ts).
 */

function DeepLinkRouter() {
  const navigate = useNavigate();

  useEffect(() => {
    // Якщо потрібно завжди відкривати Home (/), вимикаємо редіректи за кнопками з Telegram:
    /*
    const screen = getInitialScreen();
    if (screen && SCREEN_PARAM_ROUTES[screen]) {
      navigate(SCREEN_PARAM_ROUTES[screen], { replace: true });
      return;
    }
    */

    // Залишаємо тільки обробку прямих посилань (deep links на конкретне авто чи пропозицію)
    const payload = getDeepLinkPayload();
    const target = decodeDeepLink(payload);
    if (!target) return;

    track("open_miniapp", { deepLink: payload });
    switch (target.type) {
      case "car":
        navigate(`/cars/new/${target.modelSlug}`, { replace: true });
        break;
      case "proposal":
        navigate(`/proposal/${target.proposalId}`, { replace: true });
        break;
      case "credit":
        navigate(`/cars/new/${target.modelSlug}?calculate=1`, { replace: true });
        break;
      case "inventory":
      case "used_car":
        navigate(target.type === "inventory" ? "/cars/inventory" : "/cars/used", { replace: true });
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
function AppRoutes() {
  return (
    <>
      <DeepLinkRouter />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cars" element={<CarsHub />} />
        <Route path="/cars/new" element={<NewToyotaList />} />
        <Route path="/cars/new/:slug" element={<CarDetail />} />
        <Route path="/cars/inventory" element={<Inventory />} />
        <Route path="/cars/used" element={<UsedCars />} />
        <Route path="/credit" element={<Credit />} />
        <Route path="/trade-in" element={<TradeIn />} />
        <Route path="/consultants" element={<Consultants />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/proposal/:id" element={<ProposalView />} />
      </Routes>
      <BottomNav />
    </>
  );
}

export function App() {
  const hydrate = useAppStore((s) => s.hydrate);

  useEffect(() => {
    hydrate();
    track("open_miniapp");
  }, [hydrate]);

  return (
    <HashRouter>
      <div className="app-shell">
        <AppRoutes />
      </div>
    </HashRouter>
  );
}
